define('modules/auth/forms/auth.controller',["client"],
    function(Prospector)
    {
        Prospector.module("AuthApp.Forms", function(Forms, Prospector, Backbone, Marionette, $, _){
            Forms.Controller = {
                loadAuth: function(options){
                    var authView = null;
                    require(["modules/auth/forms/views/auth.view"],
                    function(AuthView){
                        document.title = 'RelPro: Authenticate';
                        window.token.fetch({success: function(){
                            authView = new AuthView();
                            Prospector.mainRegion.show(authView);
                        }});
                    });
                },
                loadLogin: function(options){
                    var loginView = null;
                    var cookieHost = window.utils.readCookie("specifiedHost");
                    // if(cookieHost == null && !window.auth.has('name')){
                    //     Prospector.navigate("auth", true);
                    // } else {
                        require(["modules/auth/forms/views/login.view"],
                        function(LoginView){
                            document.title = 'RelPro: Login';
                            window.token.fetch({
                                success: function(){
                                    loginView = new LoginView();
                                    Prospector.mainRegion.show(loginView);
                                }
                            });
                        });
                    // }
                }
            }
        });
        return Prospector.AuthApp.Forms.Controller;
    });

